import { styledComponent } from '@hermes/web-components'

export const Container = styledComponent('div')`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: linear-gradient(18deg, #A2B9F8 -15.4%, #EBEEFB 104.01%);;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 80px 20px 24px 20px;
    box-sizing: border-box;
    overflow-y: auto;
    z-index: 999;
`
